import { Controller } from "stimulus"

// #1705: het formulier van een membership type. Velden die alleen bij een
// bepaalde keuze horen (de dagen bij gelimiteerde toegang, het aantal bij een
// vaste duur, de datums bij "actief tussen") staan alleen zichtbaar als die
// keuze aan staat. De server zet ze bij het laden al goed; dit volgt de
// keuzes daarna.
//
// <div data-lidmaatschap-formulier-target="afhankelijk"
//      data-als='[["membership_type[start_rule]","between"]]'>
// Alle voorwaarden moeten kloppen; bij een voorwaarde staan de toegestane
// waarden komma-gescheiden.
export default class extends Controller {
  static targets = ["afhankelijk", "cyclus", "prijsPer", "voorbeeld", "uploadLeeg"]

  connect() {
    this.vorigeCyclus = this.hasCyclusTarget ? this.cyclusTarget.value : null
    this.bijwerken()
  }

  bijwerken(event) {
    if (event && this.hasCyclusTarget && event.target === this.cyclusTarget) this.cyclusGewijzigd()

    this.afhankelijkTargets.forEach((element) => {
      let voorwaarden = []
      try {
        voorwaarden = JSON.parse(element.dataset.als || "[]")
      } catch (_fout) {
        voorwaarden = []
      }
      element.hidden = !voorwaarden.every(([naam, waarden]) => waarden.split(",").includes(this.waarde(naam)))
    })
  }

  // De huidige waarde van een veld: bij keuzerondjes het gekozen rondje, bij
  // een schakelaar "1" of "0" (het verborgen veld ervoor telt niet mee).
  waarde(naam) {
    const velden = Array.from(this.element.querySelectorAll(`[name="${naam}"]`))
    if (velden.length === 0) return null

    const radio = velden.filter((veld) => veld.type === "radio")
    if (radio.length) return radio.find((veld) => veld.checked)?.value ?? null

    const vink = velden.find((veld) => veld.type === "checkbox")
    if (vink) return vink.checked ? vink.value : "0"

    return velden[velden.length - 1].value
  }

  // Stond de prijs "per" dezelfde periode als de betaalcyclus, dan schuift
  // die mee; anders zou een andere cyclus de prijs ongemerkt vermenigvuldigen.
  cyclusGewijzigd() {
    if (!this.hasPrijsPerTarget) return

    const nieuw = this.cyclusTarget.value
    const per = this.prijsPerTarget
    if (nieuw && (per.value === this.vorigeCyclus || this.vorigeCyclus === "")) {
      if (Array.from(per.options).some((optie) => optie.value === nieuw)) per.value = nieuw
    }
    this.vorigeCyclus = nieuw
  }

  // Een gekozen webshopafbeelding meteen tonen
  voorbeeld(event) {
    const bestand = event.target.files && event.target.files[0]
    if (!bestand || !this.hasVoorbeeldTarget) return

    const lezer = new FileReader()
    lezer.onload = () => {
      this.voorbeeldTarget.src = lezer.result
      this.voorbeeldTarget.hidden = false
      if (this.hasUploadLeegTarget) this.uploadLeegTarget.hidden = true
    }
    lezer.readAsDataURL(bestand)
  }

  // Een aantal invullen bij een activiteit zet het vinkje van die rij aan
  creditAantal(event) {
    const rij = event.target.closest("[data-credit-rij]")
    const vink = rij && rij.querySelector("input[type='checkbox']")
    if (vink && event.target.value !== "") vink.checked = true
  }
}
